import * as Progress from '@radix-ui/react-progress'
import * as React from 'react'

import { styled } from '~/styled'

const StyledProgressBar = styled(
  Progress.Root,
  {
    base: [
      'rounded-full',
      'bg-grey-200',
      'relative',
      'overflow-hidden',
      'w-full'
    ],
    variants: {
      size: {
        sm: ['h-1'],
        md: ['h-2']
      },
      theme: {
        primary: ['text-primary-800'],
        info: ['text-info'],
        success: ['text-success'],
        warning: ['text-warning'],
        danger: ['text-danger'],
        neutral: ['bg-grey-400', 'text-grey-800']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

const StyledIndicator = styled(Progress.Indicator, {
  base: [
    'bg-current',
    'rounded-full',
    'box-border',
    'h-full',
    'absolute',
    'transition-all',
    'duration-300',
    'ease-out'
  ]
})

type ProgressBarProps = React.ComponentPropsWithoutRef<
  typeof StyledProgressBar
> &
  (
    | { id: string; 'aria-label'?: string }
    | { 'aria-label': string; id?: string }
  )

export const ProgressBar = ({
  value,
  max = 100,
  size = 'md',
  theme = 'primary',
  ...remainingProps
}: ProgressBarProps) => (
  <StyledProgressBar
    value={value}
    max={max}
    theme={theme}
    size={size}
    {...remainingProps}
  >
    <StyledIndicator
      className="w-full translate-x-(--progress)"
      style={{
        '--progress': `-${100 - ((value || 0) / max) * 100}%`
      }}
    />
  </StyledProgressBar>
)

ProgressBar.displayName = 'ProgressBar'
